import HomeRoute from './Home'
import MapRoute from './Map'
import DatabaseRoute from './Database'
import AboutRoute from './About'
import AdminRoute from './AdminPanel'
import ConsortiumRoute from './Consortium'
import AdvisoryBoardRoute from './AdvisoryBoard'
import BraveFairRoute from './BraveFair'
import PublicationsRoute from './Publications'
import NotFoundRoute from './NotFound'
import NotFoundComponent from './NotFound/components/notFound'
import TrainingRoute from './Training'
import StakeholderRoute from './Stakeholder'
import ToolkitRoute from './Toolkit'
import InequalityRoute from './Inequality'
import QARoute from './QA'
import SocialmediaRoute from './Socialmedia'
import JuryRoute from './Jury'
import CulturalRoute from './Cultural'

export const createRoutes = (store) => ({
  path        : '/',
  indexRoute  : HomeRoute,
  childRoutes: [
    MapRoute(store),
    DatabaseRoute(store),
    AdminRoute(store),
    BraveFairRoute(store),
    PublicationsRoute(store),
    TrainingRoute(store),
    StakeholderRoute(store),
    ToolkitRoute(store),
    InequalityRoute(store),
    QARoute(store),
    SocialmediaRoute(store),
    JuryRoute(store),
    CulturalRoute(store),
    {
      path: 'about',
      childRoutes: [
        AboutRoute(store),
        ConsortiumRoute(store),
        AdvisoryBoardRoute(store)
      ]
    },
    {
      path: '*',
      component: NotFoundComponent,
      indexRoute: NotFoundRoute
    }
  ]
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js